import { CONNECTOR_TYPES } from '@/vars/general'

/**
 * «Горячие окна» и «Отчёт 2.0» работают только на данных YCLIENTS:
 * на проектах с другой CRM пункты скрыты, а прямой переход уводит на проект.
 */
export function hasYClientsConnector(
    project?: { connectors?: Array<{ connectorType?: string }> } | null
): boolean {
    return Boolean(project?.connectors?.some(con => con.connectorType === CONNECTOR_TYPES.yClients))
}
